(() => {
  if (window.novarloCuratedCarouselScriptInstalled) return;
  window.novarloCuratedCarouselScriptInstalled = true;
  const selector = '[data-novarlo-curated-carousel]';
  function setup(section) {
    if (section.dataset.nccReady === 'true') return;
    const viewport = section.querySelector('[data-ncc-viewport]');
    const controls = section.querySelector('[data-ncc-controls]');
    const prev = section.querySelector('[data-ncc-prev]');
    const next = section.querySelector('[data-ncc-next]');
    if (!viewport) return;
    section.dataset.nccReady = 'true';
    section.dataset.nccTooltipsReady = 'true';
    if (!controls || !prev || !next) return;
    const update = () => {
      const desktopDisabled = window.matchMedia('(min-width: 990px)').matches && section.dataset.desktopCarousel === 'false';
      const max = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      controls.hidden = desktopDisabled || max <= 2;
      prev.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= max - 2;
    };
    const scroll = direction => {
      const item = section.querySelector('.novarlo-curated-carousel__item');
      const track = section.querySelector('.novarlo-curated-carousel__track');
      const gap = track ? parseFloat(getComputedStyle(track).columnGap) || 0 : 0;
      const amount = item ? (item.getBoundingClientRect().width + gap) * Math.max(1, Math.floor(viewport.clientWidth / (item.getBoundingClientRect().width + gap))) : viewport.clientWidth;
      viewport.scrollBy({left: direction * amount, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };
    prev.addEventListener('click', () => scroll(-1));
    next.addEventListener('click', () => scroll(1));
    viewport.addEventListener('scroll', update, {passive:true});
    if (window.ResizeObserver) new ResizeObserver(update).observe(viewport);
    window.addEventListener('resize', update, {passive:true});
    update();
  }
  function init(root = document) {
    if (root.matches?.(selector)) setup(root);
    root.querySelectorAll?.(selector).forEach(setup);
  }
  // The native desktop badge tooltip is clipped by the horizontal scroller.
  // Present its existing text in a fixed overlay; keep the site's own mobile popover.
  function installDesktopTooltips() {
    const desktop = window.matchMedia('(min-width: 750px)');
    const badgeSelector = selector + ' [data-quick-ship-tooltip]';
    let overlay = null;
    let activeBadge = null;
    const getBadge = event => event.target?.closest?.(badgeSelector) || null;

    const hide = () => {
      activeBadge = null;
      if (overlay) overlay.hidden = true;
    };

    const position = () => {
      if (!overlay || overlay.hidden || !activeBadge) return;
      const rect = activeBadge.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) {
        hide();
        return;
      }

      const width = overlay.offsetWidth;
      const height = overlay.offsetHeight;
      const center = rect.left + rect.width / 2;
      const left = Math.max(12, Math.min(center - width / 2, window.innerWidth - width - 12));
      let top = rect.top - height - 12;
      let placement = 'above';

      if (top < 12) {
        top = rect.bottom + 12;
        placement = 'below';
      }

      top = Math.max(12, Math.min(top, window.innerHeight - height - 12));
      overlay.dataset.placement = placement;
      overlay.style.left = Math.round(left) + 'px';
      overlay.style.top = Math.round(top) + 'px';
      overlay.style.setProperty('--ncc-tooltip-arrow-left', Math.round(center - left) + 'px');
    };

    const show = badge => {
      if (!desktop.matches || !badge.isConnected) return;
      const content = badge.querySelector('.quick-ship-tooltip__content')?.textContent?.trim();
      if (!content) return;

      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'novarlo-curated-carousel__tooltip-overlay';
        overlay.setAttribute('aria-hidden', 'true');
        overlay.hidden = true;
        document.body.appendChild(overlay);
      }
      activeBadge = badge;
      overlay.textContent = content;
      overlay.hidden = false;
      position();
    };

    document.addEventListener('pointerover', event => {
      const badge = getBadge(event);
      if (badge && !badge.contains(event.relatedTarget)) show(badge);
    });

    document.addEventListener('pointerout', event => {
      const badge = getBadge(event);
      if (badge && !badge.contains(event.relatedTarget) && activeBadge === badge) hide();
    });

    document.addEventListener('focusin', event => {
      const badge = getBadge(event);
      if (badge) show(badge);
    });

    document.addEventListener('focusout', event => {
      const badge = getBadge(event);
      if (badge && !badge.contains(event.relatedTarget) && activeBadge === badge) hide();
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') hide();
    });

    document.addEventListener('scroll', hide, {passive: true, capture: true});
    window.addEventListener('resize', hide, {passive: true});
    desktop.addEventListener('change', hide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      installDesktopTooltips();
      init();
    });
  } else {
    installDesktopTooltips();
    init();
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
